import React from "react";
import styled from "@emotion/styled";

const StyledDiv = styled.div(({ size }) => ({
  marginBottom: size === "bold" ? "24px" : "8px",
  alignItems: size === "bold" ? "center" : "start",
}));

const StyledSpan = styled.span(({ size }) => ({
  fontSize: size === "bold" ? "20px" : "16px",
  fontWeight: 600,
}));

/**
 * TitleWithIcon Component
 * @param {string} text
 * @param {string} [icon]
 * @param {"bold" | "normal"} [size="normal"]
 */
export default function TitleWithIcon({ text, icon, size = "normal" }) {
  return (
    <StyledDiv className="r_additionalInfoTitle" size={size}>
      {icon && (
        <img
          src={icon}
          alt={text}
          style={{ marginTop: 0, marginBottom: 0, width: 24, height: 24 }}
        />
      )}
      <StyledSpan size={size}>{text}</StyledSpan>
    </StyledDiv>
  );
}
